import type { PostCard_PostData } from './PostCard'
import { Service } from '~publish/legacy/constants/services/ServiceDefinitions'

const [, ...domainParts] = window.location.hostname.split('.')
const domain = domainParts.join('.')

export const getEngageUrl = (
  channel: PostCard_PostData['channel'],
): string | null => {
  if (!channel.products?.includes('engage')) return null

  return `https://engage.${domain}`
}

export const getAnalyzeUrl = (
  channel: PostCard_PostData['channel'],
): string | null => {
  if (!channel.products?.includes('analyze')) return null

  return `https://analyze.${domain}/${channel.service}/overview/${channel.id}`
}

export const requiresRefreshing = (
  channel: PostCard_PostData['channel'],
): boolean => {
  if (channel.service !== Service.Linkedin) return false

  return !channel.scopes?.includes('r_member_postAnalytics')
}
